import { render, staticRenderFns } from "./EditorPricingTable.vue?vue&type=template&id=70002ed2&"
import script from "./EditorPricingTable.vue?vue&type=script&lang=js&"
export * from "./EditorPricingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports